'use strict';

angular.module('atex.dam').directive('thumbSlider', ['$rootScope', function($rootScope) {
  return {

    restrict: 'E',
    templateUrl: 'views/dam-thumb-slider.html',
    replace: false,

    scope: {
      min: "=",
      max: "=",
      start: "=",
      fulls: "="
    },
    controller: function ($scope) {
      var preview = [100, 100, 100, 150, 200, 250, 300];
      var fullscreen = [150, 150, 150, 200, 250, 300, 350];
      var collection = [30, 30, 30, 50, 70, 90, 110];
      var collectionwall = [55, 55, 55, 90, 140, 170, 200];
      var physical = [
        'width: 140px; min-width: 140px;',
        'width: 140px; min-width: 140px;',
        'width: 140px; min-width: 140px;',
        'width: 180px; min-width: 180px;',
        'width: 220px; min-width: 220px;',
        'width: 280px; min-width: 280px;',
        'width: 340px; min-width: 340px;'];

      var physicalHeight = [150, 150, 150, 200, 250, 350, 450];

      var physicalSingleEditionHeight = [105, 105, 105, 105, 230, 350, 750, 1350];
      var physicalSingleEditionHeightFull = [190, 190, 190, 190, 400, 630, 1250];

      var singleEdition = [
        "single-edition-entry col-xs-1 col-sm-1 col-md-1 col-lg-1 split",
        "single-edition-entry col-xs-1 col-sm-1 col-md-1 col-lg-1 split",
        "single-edition-entry col-xs-1 col-sm-1 col-md-1 col-lg-1 split",
        "single-edition-entry col-xs-1 col-sm-1 col-md-1 col-lg-1 split",
        "single-edition-entry col-xs-2 col-sm-2 col-md-2 col-lg-2 split",
        "single-edition-entry col-xs-3 col-sm-3 col-md-3 col-lg-3 split",
        "single-edition-entry col-xs-6 col-sm-6 col-md-6 col-lg-6 split",
        "single-edition-entry col-xs-12 col-sm-12 col-md-12 col-lg-12 split"];

      var singleEditionFull = [
        "single-edition-entry col-xs-1 col-sm-1 col-md-1 col-lg-1 full",
        "single-edition-entry col-xs-1 col-sm-1 col-md-1 col-lg-1 full",
        "single-edition-entry col-xs-1 col-sm-1 col-md-1 col-lg-1 full",
        "single-edition-entry col-xs-1 col-sm-1 col-md-1 col-lg-1 full",
        "single-edition-entry col-xs-2 col-sm-2 col-md-2 col-lg-2 full",
        "single-edition-entry col-xs-3 col-sm-3 col-md-3 col-lg-3 full",
        "single-edition-entry col-xs-6 col-sm-6 col-md-6 col-lg-6 full"];

      $scope.fixDisplay = function (uiValue) {
        if (uiValue) {
          $scope.start = uiValue;
        } else {
          uiValue = $scope.start;
        }

        var divs = $('.row').find('.grid-thumb-entry');

        var online = false;
        if (!divs || divs.length === 0) {
          divs = $('.row').find('.single-edition-entry');
          online = (divs && divs.length > 0);
        }

        var phys = false;
        if (!divs || divs.length === 0) {
          divs = $('.row').find('.physical-pages-entry');
          phys = (divs && divs.length > 0);
        }

        var v = (uiValue === 5) ? 6 : uiValue;

        if (!phys && !online) {
          angular.forEach(divs, function (div) {
            div.attributes['class'].value = ("col-lg-" + v) + " " + div.attributes['classes'].value;
          });
        }

        if (online) {
          var width = ($scope.fulls) ? singleEditionFull[uiValue] : singleEdition[uiValue];
          var height = ($scope.fulls) ? physicalSingleEditionHeightFull[uiValue] : physicalSingleEditionHeight[uiValue];

          angular.forEach(divs, function (div) {
            div.attributes['class'].value = width;
          });

          $('.image').attr('style', 'height:' + height + "px !important");

          $rootScope.sliderValue = width;
          $rootScope.physPageThumbHeight = "height:" + height + "px";
        }

        if (phys) {
          angular.forEach(divs, function (div) {
            div.attributes['style'].value = physical[uiValue];
          });

          $('.image').css({
            height: physicalHeight[uiValue]
          });

          $rootScope.sliderValue = physical[uiValue];
          $rootScope.physPageThumbHeight = "height:" + physicalHeight[uiValue] + "px";
        }

        if (!phys && !online) {
          $('.image').css({
            height: preview[uiValue]
          });

          $('.placeholder').css({
            height: preview[uiValue]
          });

          $('.fullscreen').css({
            height: fullscreen[uiValue]
          });

          $('.collection-img-thumb').css({
            height: collection[uiValue]
          });

          $('.collection-img-thumb-full-screen').css({
            height: collectionwall[uiValue]
          });

          var dis = 'block';
          if ((uiValue === 2) && (!$scope.fulls)) {
            dis = 'none';
          }

          var captions = $('.row').find('.caption');
          angular.forEach(captions, function (caption) {
            $('.caption').css({
              display: dis
            });
          });
        }

        $rootScope.$broadcast('dam:slider-changed');
      };
      // to set the saved display setting instead of the default ones
      $scope.$on('dam:setSliderEvent', function (event, args) {
        $scope.fixDisplay(args.display);
        $('#dam-thumb-slider').slider({value: args.display});
      });

      $scope.$on('dam:resetSliderEvent', function (event,slider) {
        $('#dam-thumb-slider').slider({value: slider.display});
      });

      $scope.$watch('fulls', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          $scope.fixDisplay();
        }
      }, true);
    },
    link: function (scope, element) {

      element.slider({
        max: scope.max,
        min: scope.min,
        value: scope.start,
        slide: function (event, ui) {
          // Moved the slide functionality to a seperate function.
          scope.fixDisplay(ui.value);
          // to save the changed display value
          scope.$root.$broadcast("dam:displayChangeEvent", {display: ui.value});
        }
      });
    }
  };
}]);